module.exports = __webpack_public_path__ + "img/azerbaijan.d9fe78f9.svg";